export default __webpack_public_path__ + "static/country-houses-e60fddd5fb6aec3bcd7f5d0a7a256b35.png";